export enum Tarifgruppe {
  E1 = 'E1',
  E2 = 'E2',
  E2X = 'E2X',
  E2U = 'E2Ü',
  E3 = 'E3',
  E4 = 'E4',
  E5 = 'E5',
  E6 = 'E6',
  E7 = 'E7',
  E8 = 'E8',
  E9A = 'E9a',
  E9B = 'E9b',
  E9C = 'E9c',
  E9 = 'E9',
  E10 = 'E10',
  E11 = 'E11',
  E12 = 'E12',
  E13 = 'E13',
  E14 = 'E14',
  E15 = 'E15',
  E15Z = 'E15Z',
  E15U = 'E15Ü',
  AT = 'AT',
  A10 = 'A10',
  A12 = 'A12',
  A13 = 'A13',
  A13Z = 'A13Z',
  A14 = 'A14',
  A14Z = 'A14Z',
  A15 = 'A15',
  A15Z = 'A15Z',
  A16 = 'A16',
}
